function isObject(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

/** Returns error.message when error is a non-null object with a string message property; otherwise undefined. */
export function getErrorMessage(error: unknown): string | undefined {
  if (isObject(error) && typeof error.message === 'string') {
    return error.message
  }
  return undefined
}

/** Returns error.stack when error is a non-null object with a string stack property; otherwise undefined. */
export function getErrorStack(error: unknown): string | undefined {
  if (isObject(error) && typeof error.stack === 'string') {
    return error.stack
  }
  return undefined
}

/** Returns error[key] when error is a non-null object containing key; otherwise undefined. */
export function getErrorField(error: unknown, key: string): unknown {
  if (isObject(error) && key in error) {
    return error[key]
  }
  return undefined
}
